import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListConsumablesInput} from '@cypro/engine/queries'
import {Consumable} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useMemo, useState} from 'react'

export function useGetConsumables({
  sort = {dir: 'asc', field: 'name'},
  filters,
  limit,
}: Omit<Partial<ListConsumablesInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<Consumable>>(createTopAnchor<Consumable>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {
          id: anchor.startRow.id,
          direction: anchor.direction,
          createdAt: anchor.startRow.createdAt,
          name: anchor.startRow.name,
        }
      : undefined

  const query = queries.products.listConsumables({
    cursor,
    sort,
    filters: {status: ['active'] as const, ...filters},
    limit,
  })
  const [consumables, meta] = useQuery(query)

  const filtersHash = useMemo(() => JSON.stringify(filters), [filters])
  useEffect(() => {
    setAnchor(createTopAnchor<Consumable>())
  }, [sort?.dir, sort?.field, filtersHash, limit])

  return {
    query,
    meta,
    consumables,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: consumables.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
